module.exports = __webpack_public_path__ + "img/polar-fancy.844b0123.svg";